// Our icons unfortunately aren't all uniform, and some look better at slightly
// bigger/smaller sizes in comparison to others. This function serves to unify
// their appearances so they all look the same size
export function getIconSize(key: string) {
    switch (key) {
        case 'notification':
        case 'help':
            return 20;
        case 'robot':
            return 24;
        case 'email':
            return 32;
        default:
            return 20;
    }
}
